export default "__VITE_ASSET__C8Hfa9l4__"